import { render, staticRenderFns } from "./MessagesFeed.vue?vue&type=template&id=09466ab1&"
import script from "./MessagesFeed.vue?vue&type=script&lang=ts&"
export * from "./MessagesFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports